export default {
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  }
}